"use client";

import { X, CheckCircle, HelpCircle } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import Image from "next/image";

interface HistoryMigratedModalProps {
  isOpen: boolean;
  onClose: () => void;
  migratedCount: number;
}

export default function HistoryMigratedModal({
  isOpen,
  onClose,
  migratedCount,
}: HistoryMigratedModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl max-w-md w-full shadow-2xl">
        {/* 모달 헤더 */}
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-600" />
            이력 반영 완료
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* 모달 내용 */}
        <div className="p-6 text-center">
          <div className="mb-4">
            <Image
              src="/main/3d_no-bg_butler_half-clothes_gamja.webp"
              alt="감자 관리인"
              width={150}
              height={150}
              className="mx-auto mb-3"
            />
            <p className="text-gray-600 text-base leading-relaxed">
              비로그인 상태로 풀었던 이력 모두 반영!
            </p>
            {migratedCount > 0 && (
              <p className="text-sm text-gray-500 mt-2 flex items-center justify-center gap-1">
                총{" "}
                <span className="font-semibold text-blue-600">
                  {migratedCount}개
                </span>
                의 문제 풀이 이력이 보존되었어요.
                <Popover>
                  <PopoverTrigger
                    aria-label="이력 보존 범위 안내"
                    className="grid h-7 w-7 place-items-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
                  >
                    <HelpCircle className="w-4 h-4" aria-hidden="true" />
                  </PopoverTrigger>
                  <PopoverContent className="w-auto max-w-xs">
                    <p className="text-sm">
                      다른 기기에서 푼 문제, 시크릿 모드에서 푼 문제는 반영되지
                      않을 수 있습니다
                    </p>
                  </PopoverContent>
                </Popover>
              </p>
            )}
          </div>

          <div className="bg-green-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-green-800">
              다른 기기에서 풀었던 문제를 확인할 수 있어요.
            </p>
          </div>
        </div>

        {/* 모달 푸터 */}
        <div className="flex justify-center p-4 border-t">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/80 transition-colors"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
